import React, { useEffect, useState } from "react";
import { Link, NavLink, useNavigate, useParams } from "react-router-dom";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Table from "react-bootstrap/Table";
import Layout from "../Components/Layout/Layout";
import { Figure } from "react-bootstrap";
import { Decryptedid } from "../Util/BcruptEncyptid";
import { useDispatch, useSelector } from "react-redux";
import {
  deleteuserAction,
  memberprofiledetailsAction,
  updatememberprofileAction,
  updateprofilepicAction,
  userActivityaddAction,
  usersuspendedAction,
  volunteerlogdetailsAction,
} from "../Redux/Action/AdminstratorAction";

import moment from "moment";

export default function LogsView() {
  const dispatch = useDispatch();
  const [object, Setobject] = useState({});
  const { id } = useParams();
  useEffect(() => {
    dispatch(
      volunteerlogdetailsAction({
        id: id,
      })
    ).then(function(data) {
      Setobject(data?.payload?.volunteerlistdata?.details);
    });
  }, [id]);
  return (
    <Layout>
      <div className="right-top">
        <div className="heading-top-inner">
          <div>
            <h2>Logs View</h2>
          </div>
        </div>
        <hr />
      </div>
      <Container fluid>
        <div className="product-cmn-tab mb-4 pe-4">
          <Row>
            <Col lg={4}>
              <div className="product-tab-left">
                <Link to="/volunteer-management">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="40"
                    height="42"
                    viewBox="0 0 40 42"
                    fill="none"
                  >
                    <path
                      d="M10 21L8.91379 22.0345L7.92857 21L8.91379 19.9655L10 21ZM30 19.5C30.8284 19.5 31.5 20.1716 31.5 21C31.5 21.8284 30.8284 22.5 30 22.5V19.5ZM15.5805 29.0345L8.91379 22.0345L11.0862 19.9655L17.7529 26.9655L15.5805 29.0345ZM8.91379 19.9655L15.5805 12.9655L17.7529 15.0345L11.0862 22.0345L8.91379 19.9655ZM10 19.5H30V22.5L10 22.5L10 19.5Z"
                      fill="#40413A"
                    />
                  </svg>{" "}
                  Back to previous page
                </Link>
              </div>
            </Col>
            <Col
              lg={8}
              md={8}
              className="d-flex justify-content-end align-items-center p-0"
            ></Col>
          </Row>
        </div>
      </Container>
      <Container fluid className="height-set px-4 mt-4">
        <Row>
          <Col lg={12}>
            <Row className="justify-content-center">
              <Container fluid>
                <Row className="justify-content-center"></Row>
              </Container>

              <Col lg={8}>
                <div className="mb-4 user-profile-main customer-form-new">
                  <div className="customer-form-inner">
                    <Row>
                      <Col lg={6}>
                        <div className="log-view">
                          <h2>Name</h2>
                          <p>{object?.name}</p>
                        </div>
                      </Col>
                      <Col lg={6}>
                        <div className="log-view">
                          <h2>Organization</h2>
                          <p>{object?.organizationname}</p>
                        </div>
                      </Col>
                      <Col lg={6}>
                        <div className="log-view">
                          <h2>PhoneNumber</h2>
                          <p>{object?.phonenumber}</p>
                        </div>
                      </Col>
                      <Col lg={6}>
                        <div className="log-view">
                          <h2>Purpose of Visit</h2>
                          <p>{object?.visit}</p>
                        </div>
                      </Col>
                      <Col lg={6}>
                        <div className="log-view">
                          <h2>Device Location</h2>
                          <p>{object?.locationname}</p>
                        </div>
                      </Col>
                      <Col lg={6}>
                        <div className="log-view">
                          <h2>Address</h2>
                          <p>{object?.address}</p>
                        </div>
                      </Col>
                     

                      <Col lg={6}>
                        <div className="log-view">
                          <h2>Date</h2>
                          <p>{moment(object?.intime).format("DD/MM/YYYY")}</p>
                        </div>
                      </Col>
                      <Col lg={6}>
                        <div className="log-view">
                          <h2>Login Details</h2>
                          <p>{moment(object?.intime).format("HH:mm")}</p>
                        </div>
                      </Col>
                      <Col lg={6}>
                        <div className="log-view">
                          <h2>Logout Details</h2>
                          <p>
                            {object?.outtime == undefined
                              ? ""
                              : moment(object?.outtime).format("HH:mm")}
                          </p>
                        </div>
                      </Col>
                      <Col lg={6}>
                        <div className="log-view">
                          <h2>Volunteer Form</h2>
                          <NavLink to={"/completed-form/" + object?._id}>
                            {" "}
                            <p>View form</p>
                          </NavLink>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
    </Layout>
  );
}
